module.exports = __webpack_public_path__ + "static/media/bookstore.ee3bccd5.jpg";